module.exports = __webpack_public_path__ + "static/media/tweete.71e5499f.svg";